export class FactoryDto {
  id: number;
  name: string;
  address: string;
  createdUser: any;
  isActive:boolean;
  versionFlag: number;
}

